import {StoppedMainEquipment} from '@hconnect/common/components/processFormFields'
import {useFormInputLabelWithSuffix} from '@hconnect/common/hooks'
import React, {FC, ReactNode} from 'react'
import {useTranslation} from 'react-i18next'

import {COMMON_SHIFT_EVENT_WIDGET_NAMESPACE} from '../../consts'

type EventStoppedMainEquipmentSearchProps = {
  plantId: string
  errorText?: ReactNode
  onChange: (equipment?: string) => void
  value?: string
  required?: boolean
  disabled?: boolean
  availableDepartmentCodes?: string[]
  label?: ReactNode
}

export const EventStoppedMainEquipmentSearch: FC<EventStoppedMainEquipmentSearchProps> = ({
  label: optionalLabel,
  ...props
}) => {
  const {t} = useTranslation(COMMON_SHIFT_EVENT_WIDGET_NAMESPACE)

  const defaultLabel = useFormInputLabelWithSuffix({
    label: t('shiftEvent.label.stoppedMainEquipment'),
    optional: !props.required,
    optionalTKey: t('shiftEvent.label.optional')
  })

  return <StoppedMainEquipment label={optionalLabel || defaultLabel} {...props} />
}
